const firebaseConfig = {
  apiKey: "AIzaSyBD9RZuPNWFk5QgOgW7T-t34W4QnsNYkuE",
  authDomain: "mentex-5b2ed.firebaseapp.com",
  projectId: "mentex-5b2ed",
  storageBucket: "mentex-5b2ed.appspot.com",
  messagingSenderId: "716479669508",
  appId: "1:716479669508:web:726ef5bc692da1fca8dc51"
};

export default firebaseConfig